import type { Discount } from '@optionway/models';

interface DiscountStore {
  discount?: Discount;
}

export const useDiscountStore = defineStore('discount', {
  state: (): DiscountStore => ({
    discount: undefined,
  }),
  getters: {
    toBody: (state) => {
      const amount = useShoppingCartStore().amountToPay + (state.discount?.amount ?? 0);
      return (code: string): Discount => ({ code, amount });
    },
  },
});
